export enum DocumentTypeEnum {
    Communication = "CertificateRequestCommunication",
    Assets = "CertificateRequestAssets",
    Fleet = "InsuranceRequestFleet",
    BrokerSelectionDeclaration = "InsuranceBrokerSelectionDeclaration",
}